module.exports = __webpack_public_path__ + "static/media/close-icon.86424a5f.svg";